/* @flow */
/* eslint-disable camelcase */
import type { ConnectionFeature } from "./types";

export default function Connection(feature: ConnectionFeature) {
  return {
    connection_protocol: feature.protocol,
    connection_strength: feature.signal_strength,
    is_connected: feature.is_connected,
  };
}



// WEBPACK FOOTER //
// ./src/models/mixins/device_features/connection.js